module.exports = __webpack_public_path__ + "static/icons/icon-mi-agente.6af428e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-mis-seguros/icon-mi-agente.svg
// module id = hn+p
// module chunks = 1